import React, { useEffect, useState } from "react";
import { Button, Collapse, Divider, Link, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { Box, Stack } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import {
  colorSchemes,
  crossIcon,
  crossIconDiv,
  fontSizeSchemes,
} from "../../../assets/commonFunction";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import TaskStatusButton from "../../../components/TaskStatusButton/TaskStatusButton";
import {
  MessageType,
  priorityValueColor,
  priorityValueLable,
} from "../../../utils/constant";
import { personIconStyle } from "../../../assets/commonFunction";
import PersonIcon from "../../../assets/images/chats/person.svg";
import AiCircle from "../../../assets/images/chats/aiCircle.svg";
import selectedTick from "../../../assets/images/chats/selectedTick.svg";

import moment from "moment";
import HandleLink from "./HandleLink";
import { getFileIconUrl, handleOpenFile, isGoogleYoutubeUrl } from "../../../utils/findextension";
import { handleMediaDownload } from "../../../appStore/actions/ArkchatGroup/action";
import { handleGetAiSubTaskSuggestion } from "../../../appStore/actions/ArkchatGroup/action";
import AILoder from "../AI/AILoder";

export const classes = {
  chatUserprofile: {
    bgcolor: "#E3E1E1",
    width: "30px",
    height: "30px",
    display: "flex",
    display: "-webkit-box",
    display: "-ms-flexbox",
    display: "-webkit-flex,",
    alignContent: "center",
    flexWrap: "wrap",
    justifyContent: "center",
    WebkitBoxPack: "center",
    msFlexPack: "center",
    borderRadius: "0.15rem",
    fontWeight: "500",
    objectFit: "cover",
    img: {
      height: "100%",
      width: "100%",
      objectFit: "cover",
      borderRadius: "3px",
    },
  },
  userlink: {
    color: "#2C86FF",
    lineHeight: "15px",
    fontSize: "13px",
    fontWeight: "450",
  },
  duetime: {
    color: "#000",
    opacity: "80%",
    fontSize: "13px",
    paddingTop: "1px",
  },
  userlink2: {
    color: "#2C86FF",
    display: "inline-block",
    fontSize: "0.75rem",
  },
  userInfo: {
    marginTop: "-5px !important",
    width: "100%",
  },
  pendingT: {
    borderRadius: "4px",
    padding: "5px 10px",
    height: "30px",
    textAlign: "center",
    maxHeight: "1.5rem",
    justifyContent: "center",
  },
  txt: {
    marginLeft: "2px !important;",
    color: colorSchemes.themeRedColor,
    fontSize: fontSizeSchemes.font12,
    fontWeight: 500,
  },
  chatRep: {
    background: "#E3E1E1",
    padding: "4px 10px",
    borderRadius: "3px",
    margin: "10px 0 8px",
    // cursor:"pointer"
  },
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};

const ParentMessageDisplayBox = ({ item }) => {
  const { t } = useTranslation();
  const appConstant = t("AppConstant", { returnObjects: true });
  const appContent = t("AppContent", { returnObjects: true });
  const { currentUserData, groupTopicData } = useAppSelectors();
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch();
  return (
    <Box width={"100%"} key={item?.timetoken} bgcolor={"#F6F6F6"}>
      <Box width={"100%"}>
        {(item?.type === 0 ||
          item?.type === 3 ||
          item?.type === 1 ||
          item?.type === 2) && (
          <>
            <Stack
              direction="row"
              width={"100%"}
              padding={"0.6rem"}
              justifyContent={"space-between"}
              id={`replied-message-${item?.temp_timetoken}`}
            >
              <div style={{ width: "100%" }}>
                <Stack width={"100%"} direction="row" spacing={1}>
                  {/* ------------profile section--------------- */}
                  {item?.from?.pp ? (
                    <Box sx={{ ...classes.chatUserprofile }}>
                      <img src={item?.from?.pp} alt="profile" height="100%" />
                    </Box>
                  ) : (
                    <Box
                      bgcolor={"#E3E1E1"}
                      width={"30px"}
                      height={"30px"}
                      display={"flex"}
                      flex={"none"}
                      alignItems={"center"}
                      flex-wrap={"wrap"}
                      justifyContent={"center"}
                      borderRadius={"0.15rem"}
                    >
                      <img
                        style={personIconStyle}
                        src={PersonIcon}
                        alt="individual"
                      />
                    </Box>
                  )}
                  {/* ------------Details section--------------- */}
                  <Box width={"100%"} paddingRight={2}>
                    <Stack
                      direction="row"
                      spacing={1}
                      width={"100%"}
                      justifyContent={"space-between"}
                    >
                      <Box sx={{ width: "89%", display: "flex" }}>
                        <Typography variant="subtitle2" fontWeight={"450"}>
                          {item?.from?.name}
                        </Typography>
                        <Typography
                          sx={{ ...classes.duetime, marginLeft: "0.5rem" }}
                        >
                          {/* Time */}
                          {moment(Math.floor(item?.timetoken / 10000)).format(
                            currentUserData?.timeFormat === "24"
                              ? currentUserData?.userDateTimeFormat
                              : currentUserData?.userDateTimeFormat,
                          )}
                        </Typography>
                      </Box>
                    </Stack>
                    <Typography
                      variant="subtitle2"
                      display={"inline-block"}
                      sx={classes.userlink}
                    >
                      {item?.is_all_group_member
                        ? "To all group members"
                        : `To ${item?.to[0]?.name}${
                            item?.to?.length > 1
                              ? `, and ${item?.to?.length - 1} more`
                              : ""
                          }`}
                    </Typography>

                    {/* text message */}
                    <Box width={"100%"}>
                      <HandleLink>
                        {item?.translations &&
                        item?.translations[
                          item?.to?.find(
                            (data) => data?.id === currentUserData?.id,
                          )?.languageCode
                        ] ? (
                          <Typography
                            sx={{ wordWrap: "break-word" }}
                            width={"100%"}
                            variant="body2"
                          >
                            {!expanded &&
                              item?.to?.findIndex(
                                (idData) => idData?.id === currentUserData?.id,
                              ) !== -1 &&
                              item?.translations[
                                item?.to?.find(
                                  (data) => data?.id === currentUserData?.id,
                                )?.languageCode
                              ]
                                ?.slice(0, 200)
                                ?.split(/\n/)
                                ?.map((line, indx) => (
                                  <span
                                    key={line + indx + "xyz007"}
                                    style={{
                                      marginBottom: "0.5rem",
                                      display: "block",
                                      border:
                                        line === ""
                                          ? "1px solid transparent"
                                          : "none",
                                    }}
                                  >
                                    <>{line === "" ? " " : line}</>
                                  </span>
                                ))}{" "}
                            {!expanded &&
                            item?.translations[
                              item?.to?.find(
                                (data) => data?.id === currentUserData?.id,
                              )?.languageCode
                            ]?.length > 200
                              ? " ..."
                              : ""}
                            <Collapse
                              sx={{ wordWrap: "break-word" }}
                              in={expanded}
                              timeout="auto"
                              unmountOnExit
                            >
                              {item?.to?.findIndex(
                                (idData) => idData?.id === currentUserData?.id,
                              ) !== -1 &&
                                item?.translations[
                                  item?.to?.find(
                                    (data) => data?.id === currentUserData?.id,
                                  )?.languageCode
                                ]
                                  ?.split(/\n/)
                                  ?.map((line, indx) => (
                                    <span
                                      key={line + indx + "xyz008"}
                                      style={{
                                        marginBottom: "0.5rem",
                                        display: "block",
                                        border:
                                          line === ""
                                            ? "1px solid transparent"
                                            : "none",
                                      }}
                                    >
                                      <>{line === "" ? " " : line}</>
                                    </span>
                                  ))}
                            </Collapse>
                            {item?.translations[
                              item?.to?.find(
                                (data) => data?.id === currentUserData?.id,
                              )?.languageCode
                            ]?.length > 200 && (
                              <Typography
                                variant="body2"
                                width={"100%"}
                                expand={expanded}
                                onClick={() => setExpanded(!expanded)}
                                aria-expanded={expanded}
                                aria-label="show more"
                                sx={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                display={"inline"}
                                color={"#2C86FF"}
                              >
                                {expanded ? "less" : "more"}
                              </Typography>
                            )}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{ wordWrap: "break-word" }}
                            width={"100%"}
                            variant="body2"
                          >
                            {!expanded &&
                              item?.to?.findIndex(
                                (idData) => idData?.id === currentUserData?.id,
                              ) !== 1 &&
                              item?.message?.slice(0, 200) +
                                (item?.message?.length > 200 ? " ..." : "")}
                            <Collapse
                              in={expanded}
                              timeout="auto"
                              unmountOnExit
                            >
                              {item?.to?.findIndex(
                                (idData) => idData?.id === currentUserData?.id,
                              ) !== 1 &&
                                item?.message?.split(/\n/).map((line, indx) => (
                                  <span
                                    key={line + indx + "xyz009"}
                                    style={{
                                      marginBottom: "0.5rem",
                                      display: "block",
                                      border:
                                        line === ""
                                          ? "1px solid transparent"
                                          : "none",
                                    }}
                                  >
                                    {line}
                                  </span>
                                ))}
                            </Collapse>

                            {item?.message?.length > 200 && (
                              <Typography
                                variant="body2"
                                width={"100%"}
                                expand={expanded}
                                onClick={() => setExpanded(!expanded)}
                                aria-expanded={expanded}
                                aria-label="show more"
                                sx={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                display={"inline"}
                                color={"#2C86FF"}
                              >
                                {expanded ? "less" : "more"}
                              </Typography>
                            )}
                          </Typography>
                        )}
                      </HandleLink>
                    </Box>
                    {/* -----------------subUser details------------------ */}
                    {item?.type !== 0 && item?.type != 3 && (
                      <>
                        <Stack
                          mt={"0.8rem"}
                          direction="row"
                          spacing={1}
                          gap={"2.5rem"}
                          width={"100%"}
                          justifyContent={"space-between"}
                        >
                          <Stack
                            width={"90%"}
                            alignItems={"center"}
                            direction="row"
                            spacing={1}
                          >
                            {item?.assignee?.pp ? (
                              <Box
                                sx={{
                                  ...classes.chatUserprofile,
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  src={item?.assignee?.pp}
                                  alt="profile"
                                  height="100%"
                                />
                              </Box>
                            ) : (
                              <Box
                                sx={{ cursor: "pointer" }}
                                bgcolor={"#E3E1E1"}
                                width={"27px"}
                                height={"27px"}
                                display={"flex"}
                                flex={"none"}
                                alignItems={"center"}
                                flex-wrap={"wrap"}
                                justifyContent={"center"}
                                borderRadius={"0.15rem"}
                              >
                                <Typography variant="h6" fontSize={"0.75rem"}>
                                  {item?.assignee?.name &&
                                    item?.assignee?.name[0]}
                                </Typography>
                              </Box>
                            )}
                            <Box>
                              <Box sx={classes.userInfo}>
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  flexDirection={"row"}
                                  alignItems={"center"}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    fontWeight={"400"}
                                    fontSize={"0.75rem"}
                                  >
                                    {item?.type === MessageType?.Approval
                                      ? "Approval"
                                      : item?.is_main
                                        ? "Task"
                                        : "Subtask"}{" "}
                                    : {item?.assignee?.name}
                                  </Typography>
                                  {/* Pending Button */}
                                  <TaskStatusButton
                                    item={item}
                                    status="approval"
                                  />
                                  <TaskStatusButton item={item} status="task" />
                                </Stack>
                              </Box>
                            </Box>
                          </Stack>
                        </Stack>

                        <Box display={"flex"}>
                          <Box
                            width="75%"
                            ml={"2.18rem"}
                            display={"flex"}
                            gap={"0.2rem"}
                            flexDirection={"column"}
                          >
                            <Typography
                              variant="subtitle2"
                              fontSize={"0.75rem"}
                              lineHeight={"15px"}
                            >
                              {item?.type === MessageType?.Approval
                                ? appContent?.KEY343
                                : appContent?.KEY342}{" "}
                              :{" "}
                              {moment(
                                Math.floor(item?.timetoken / 10000),
                              ).format(currentUserData?.userDateFormat)}
                            </Typography>

                            <Typography
                              variant="subtitle2"
                              lineHeight={"15px"}
                              fontSize={"0.75rem"}
                            >
                              {" "}
                              Due on :{" "}
                              {moment(item?.due_date).format(
                                currentUserData?.userDateFormat,
                              )}{" "}
                              {moment(item?.due_time, "HH:mm").format(
                                currentUserData?.userTimeFormat,
                              )}
                            </Typography>

                            <Box>
                              <Typography
                                variant="subtitle2"
                                fontSize={"0.75rem"}
                                lineHeight={"15px"}
                              >
                                {item?.type === MessageType?.Task
                                  ? "Task"
                                  : "Approval"}{" "}
                                Priority :
                                <span
                                  style={{
                                    display: "inline-block",
                                    width: "13px",
                                    height: "13px",
                                    verticalAlign: "middle",
                                    margin: "-1px 5px 0px 5px",
                                    backgroundColor:
                                      priorityValueColor[item?.priority],
                                  }}
                                ></span>
                                {priorityValueLable[item?.priority]}
                              </Typography>
                            </Box>

                            {item?.start_time > 0 && (
                              <>
                                <Typography
                                  variant="subtitle2"
                                  fontSize={"0.75rem"}
                                  lineHeight={"15px"}
                                >
                                  Started :{" "}
                                  {moment
                                    .unix(item?.start_time)
                                    .format(
                                      currentUserData?.data?.userDateFormat,
                                    )}
                                </Typography>
                              </>
                            )}

                            {item?.end_time > 0 && (
                              <>
                                <Typography
                                  variant="subtitle2"
                                  fontSize={"0.75rem"}
                                  lineHeight={"15px"}
                                >
                                  Finished :{" "}
                                  {moment
                                    .unix(item?.end_time)
                                    .format(
                                      currentUserData?.data?.userDateFormat,
                                    )}
                                </Typography>
                              </>
                            )}
                            {item?.estimated_time?.timeValue && (
                              <>
                                <Typography
                                  variant="subtitle2"
                                  fontSize={"0.75rem"}
                                  lineHeight={"15px"}
                                >
                                  Estimated time :{" "}
                                  {item?.estimated_time?.timeValue}{" "}
                                  {item?.estimated_time?.timeType}
                                </Typography>

                                {item?.actual_time?.timeValue && (
                                  <>
                                    <Typography
                                      variant="subtitle2"
                                      fontSize={"0.75rem"}
                                      lineHeight={"15px"}
                                    >
                                      Actual Time :{" "}
                                      {item?.actual_time?.timeValue}{" "}
                                      {item?.actual_time?.timeType}
                                    </Typography>
                                  </>
                                )}
                              </>
                            )}
                            {item?.estimated_time?.timeValue && (
                              <Box>
                                {item?.end_time > 0 && (
                                  <>
                                    <Typography
                                      color={
                                        item?.actual_time?.timeValue <
                                          item?.estimated_time?.timeValue ||
                                        Math.abs(item?.diff_time?.timeValue) ===
                                          0
                                          ? "#007F8F"
                                          : "#DB0011"
                                      }
                                      fontSize={"0.75rem"}
                                    >
                                      {Math.abs(item?.diff_time?.timeValue) >
                                      0 ? (
                                        <>
                                          {Math.abs(item?.diff_time?.timeValue)}{" "}
                                          {item?.diff_time?.timeType}{" "}
                                          {item?.actual_time?.timeValue <
                                          item?.estimated_time?.timeValue
                                            ? "Less"
                                            : "More"}
                                        </>
                                      ) : (
                                        <>{appContent?.KEY270}</>
                                      )}
                                    </Typography>
                                  </>
                                )}
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </>
                    )}

                    {/* -----------------Attachments------------------ */}
                    {item?.attachments?.length > 0 && (
                      <Box mt={"0.5rem"}>
                        {item?.attachments?.map((fileData) => (
                          <Box
                            key={fileData?.location}
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                              if (isGoogleYoutubeUrl(fileData?.location)) {
                                window.open(fileData?.location, "_blank");
                              } else {
                                handleOpenFile(dispatch, fileData, handleMediaDownload);
                              }
                            }}
                          >
                            <Box
                              display={"flex"}
                              alignItems={"center"}
                              gap={"0.2rem"}
                            >
                              <img
                                style={{ height: "25px", width: "25px" }}
                                src={getFileIconUrl(fileData?.location)}
                                alt={fileData?.name}
                              />
                              <Typography
                                variant="subtitle2"
                                fontWeight={"400"}
                                fontSize={"0.75rem"}
                              >
                                {fileData?.name}
                              </Typography>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )}

                    {/* Which Topic */}
                    <Stack
                      direction="row"
                      ml={item?.type === MessageType?.Message ? 0 : "2.18rem"}
                      alignItems={"center"}
                      sx={{ flexWrap: "nowrap", overflow: "hidden" }}
                    >
                      <Box
                        display={"flex"}
                        gap={"0.2rem"}
                        alignItems={"center"}
                        pr={1}
                        sx={{ flexShrink: 0 }}
                      >
                        <Typography fontSize={"0.75rem"}>Topic : </Typography>
                        <Typography
                          title={
                            groupTopicData?.data?.length > 0 &&
                            groupTopicData?.data?.find(
                              (data) => data?.id === item?.topic_id,
                            )?.name
                          }
                          sx={{
                            ...classes.userlink2,
                            maxWidth: "100%",
                          }}
                        >
                          {groupTopicData?.data?.length > 0 &&
                            (() => {
                              const name = groupTopicData?.data?.find(
                                (data) => data?.id === item?.topic_id,
                              )?.name;
                              return name?.length > 80
                                ? name.substring(0, 80) + "..."
                                : name;
                            })()}
                        </Typography>{" "}
                      </Box>
                    </Stack>
                  </Box>
                </Stack>
              </div>
            </Stack>
            <Box
              width={"100%"}
              margin={"auto"}
              border={"1px solid #ECECEC"}
            ></Box>
          </>
        )}
      </Box>
    </Box>
  );
};

const SuggestedSubTaskList = ({
  subTaskList,
  handleUseSubTask,
  selectedSubTask,
}) => {
  return (
    <Box
      sx={{
        p: 2,
      }}
    >
      {/* Header */}
      <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
        <Box
          sx={{
            width: 32,
            height: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={AiCircle} alt="aiLogo" />
        </Box>

        <Typography fontSize={14} fontWeight={500}>
          Select and assign subtasks one by one. Edit subtask in the next screen
        </Typography>
      </Stack>

      {/* List */}
      <Stack spacing={1}>
        {subTaskList.map((task, index) => (
          <React.Fragment key={index}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography fontSize={14}>{task}</Typography>

              <Button
                onClick={() => handleUseSubTask(task, index)}
                // variant="outlined"
                disabled={selectedSubTask?.includes(index)}
                size="small"
                sx={{
                  textTransform: "none",
                  borderRadius: 1,
                  minWidth: 64,
                  color: "#000000",
                  border: "1px solid #000000",
                }}
              >
                {selectedSubTask?.includes(index) ? (
                  <img src={selectedTick} alt="selected" />
                ) : (
                  "Use it"
                )}
              </Button>
            </Box>

            {index !== subTaskList.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Stack>
    </Box>
  );
};

const SubTaskAISuggestionDrawer = ({
  onClose,
  setNewMessages,
  selectedSubTask,
  setSelectedSubTask,
  setIsThreadTaskTypeModalOpen,
  setTaskModalDeatils,
  handleclickAttherate,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { threadMsgList } = useAppSelectors();
  const [subTaskList, setSubTaskList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleUseSubTask = (task, taskIndx) => {
    setSelectedSubTask([...selectedSubTask, taskIndx]);
    setNewMessages(task);
    setIsThreadTaskTypeModalOpen(false);
    let taskObject = {
      title: appContent?.KEY306,
      type: MessageType?.AssignSubTask,
      subHeader: appContent?.KEY250,
      buttonname: appContent?.KEY306,
      title2: appContent?.KEY306,
      msgType: MessageType?.AssignSubTask,
    };
    setTaskModalDeatils(taskObject);
    handleclickAttherate(MessageType?.Task);
  };

  const handleCloseDrawer = () => {
    onClose(false)
    setSelectedSubTask([])
  }

  useEffect(() => {
    if (threadMsgList?.length > 0) {
      setLoading(true);
      dispatch(
        handleGetAiSubTaskSuggestion({ task: threadMsgList[0]?.message }),
      ).then((res) => {
        setSubTaskList(res?.data || []);
        setLoading(false);

      });
    }
  }, []);

  return (
    <Box sx={classes?.drawerBody}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={classes.header}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography sx={classes.iconDiv}>
            <CloseIcon sx={classes.iconn} onClick={handleCloseDrawer} />
          </Typography>
          <Typography color={"black"}>Subtask Suggestions</Typography>
        </Stack>
      </Stack>

      <Box>
        <Box>
          <ParentMessageDisplayBox item={threadMsgList?.[0] || {}} />
        </Box>
        <Box
          sx={{
            position: "relative",
            height: "48vh",
            overflow: "auto",
            scrollBehavior: "smooth",
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "3px",
            },
            "@media (max-width: 1194px)": {
              height: "48vh",
            },
          }}
        >
          <SuggestedSubTaskList
            subTaskList={subTaskList}
            handleUseSubTask={handleUseSubTask}
            selectedSubTask={selectedSubTask}
          />
          {isLoading&&<AILoder />}
        </Box>
        <Box textAlign="center" padding="0.5rem">
          <Button
            onClick={() => onClose(false)}
            size="small"
            sx={{
              textTransform: "none",
              borderRadius: 1,
              minWidth: 64,
              color: "#000000",
              padding:"0.2rem 0.6rem",
              border: "1px solid #000000",
            }}
          >
            Finished Assigning
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SubTaskAISuggestionDrawer;
